import React, { useState, useEffect, useRef } from 'react';

const COUNTERS = {};
const SELFS = {};
const STATE = {};

function storage(WrappedComponent, keyState, defParams = {}) {
    const Storage = (props) => {
        const [forceUpdate, setForceUpdate] = useState(0);
        const indexRef = useRef(null);
        const setStorageRef = useRef(null);

        useEffect(() => {
            if (!STATE[keyState]) {
                STATE[keyState] = {
                    ...defParams
                };

                SELFS[keyState] = {};
                COUNTERS[keyState] = 0;
            }

            indexRef.current = COUNTERS[keyState];
            SELFS[keyState][indexRef.current] = { forceUpdate: setForceUpdate };
            COUNTERS[keyState] += 1;

            setStorageRef.current = (data) => {
                for (let key in data) {
                    STATE[keyState][key] = data[key];
                }

                for (let key in SELFS[keyState]) {
                    let self = SELFS[keyState][key];
                    self.forceUpdate(prev => prev + 1);
                }
            };

            return () => {
                delete SELFS[keyState][indexRef.current];

                if (!Object.keys(SELFS[keyState]).length) {
                    delete STATE[keyState];
                    COUNTERS[keyState] = 0;
                }
            };
        }, []);

        const sharedState = STATE[keyState] || defParams;
        const safeSetStorage = setStorageRef.current || (() => {});

        return <WrappedComponent
            {...sharedState}
            setStorage={safeSetStorage}
        />;
    };

    Storage.displayName = `Storage(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

    return Storage;
}

export default storage;
